module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7RhXv3/tc-custom/9781439132029.jpg?1730490465709",
      "alt": "This image is the cover for the book Egypt Game"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Egypt Game\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A children’s fantasy game in an abandoned lot leads to unexpected trouble in this classic, Newburn Honor–winning book.")]), _c('br'), _c('br'), _vm._v("The first time Melanie Ross meets April Hall, she’s not sure they’ll have anything in common. But she soon discovers that they both love anything to do with ancient Egypt. When they stumble upon a deserted storage yard behind the A-Z Antiques and Curio Shop, Melanie and April decide it’s the perfect spot for them to play the Egypt Game."), _c('br'), _c('br'), _vm._v("Before long there are six Egyptians instead of two. After school and on weekends they all meet to wear costumes, hold ceremonies, and work on their secret code. Everyone thinks it’s just a game, until strange things begin happening to the players. Has the Egypt Game gone too far?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Zilpha Keatley Snyder\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Zilpha Keatley Snyder (b. 1927) is a three-time Newbery Honor–winning author of adventure and fantasy novels for children. Her smart, honest, and accessible narrative style has made her books beloved by generations. When not writing, she enjoys reading and traveling. Snyder lives in Mill Valley, California.     ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Atheneum Books for Young Readers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0